import React from 'react'
import Chart from 'react-apexcharts';
const PieChart = ({android,ios,normal,premium}) => {

const chartOption = {
    chart:{
      type:"pie"
    },
    labels:['Android Users','IOS Users'],
    colors: ['#00E396', '#008FFB'],
    title: {
      text: 'Android & IOS',
      align: 'center',
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }
    ]
  }

  const chartOption2 = {
    chart:{
      type:"pie"
    },
    labels:['Free Users','Premium Users'],
    colors: ['#BA4FA1', '#FEBA17'],
    title: {
      text: 'Free Users & Premium Users',
      align: 'center',
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }
    ]
  }

  const chartSeries = [android,ios]
  const chartSeries2 = [parseInt(normal),parseInt(premium)]

  return (
    <div id="chart" className="d-flex flex-row my-4" >
        <Chart style={{backgroundColor:"white",padding:"2rem"}}  options={chartOption} series={chartSeries} type="pie" width="450" />
        <Chart style={{backgroundColor:"white",padding:"2rem"}} options={chartOption2} series={chartSeries2} type="pie" width="450" />
    </div>
  )
}

export default PieChart